import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
export interface SelectMesProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  filterOptions?: number[];
  ano?: string;
  useNumericValue?: boolean;
}

function SelectMes({
  value,
  filterOptions = [],
  ano,
  useNumericValue = false,
  ...rest
}: SelectMesProps) {
  const options = [
    {
      label: "Janeiro",
      value: useNumericValue ? 1 : `${ano}-01`,
    },
    {
      label: "Fevereiro",
      value: useNumericValue ? 2 : `${ano}-02`,
    },
    {
      label: "Março",
      value: useNumericValue ? 3 : `${ano}-03`,
    },
    {
      label: "Abril",
      value: useNumericValue ? 4 : `${ano}-04`,
    },
    {
      label: "Maio",
      value: useNumericValue ? 5 : `${ano}-05`,
    },
    {
      label: "Junho",
      value: useNumericValue ? 6 : `${ano}-06`,
    },
    {
      label: "Julho",
      value: useNumericValue ? 7 : `${ano}-07`,
    },
    {
      label: "Agosto",
      value: useNumericValue ? 8 : `${ano}-08`,
    },
    {
      label: "Setembro",
      value: useNumericValue ? 9 : `${ano}-09`,
    },
    {
      label: "Outubro",
      value: useNumericValue ? 10 : `${ano}-10`,
    },
    {
      label: "Novembro",
      value: useNumericValue ? 11 : `${ano}-11`,
    },
    {
      label: "Dezembro",
      value: useNumericValue ? 12 : `${ano}-12`,
    },
  ];

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options.filter(
        (option) => !filterOptions.includes(Number(option.value))
      )}
      {...rest}
    />
  );
}

export default SelectMes;
